<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iii">The female VISION</a></h1><a id="page_iii">
<p class="subtitle"><strong>Women’s Real Power at Work</strong></p>
<p class="author"><strong>SALLY HELGESEN &amp; JULIE JOHNSON</strong></p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?00dca92a